import { ProjectEstimateService as pes } from '../api/ProjectEstimateService';
import { useQuery } from 'react-query';
import { useStore } from 'zustand';
import { useUnityBuildStore } from '../stores/store';

export function useFetchEstimates() {
  const { selectedProject } = useStore(useUnityBuildStore);

  const { data, error, isLoading, refetch } = useQuery(
    ['estimates', selectedProject.id],
    async () => {
      if (selectedProject.id) {
        const response = await pes.fetchEstimates(selectedProject.id);
        return response.estimateList;
      }
      throw new Error('No valid ID available for fetching contracts');
    },
    {
      enabled: !!selectedProject.id,
    }
  );
  return { data, error, isLoading, refetch };
}

//list estimate statuses
export const useFetchEstimateStatuses = () => {
  const { data, error, isLoading } = useQuery('estimateStatuses', async () => {
    const response = await pes.listEstimateStatuses();
    return response.estimatestatusList;
  });
  return { data, error, isLoading };
};
